import { BaseComponent } from '../BaseComponent';
import { ComponentNames } from 'src/app/helper/componentNames';

export class ArmrestBetweenSeatComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.armrestBetweenSeatComponent;
    }
    armrestBetweenSeats: boolean;
}